
import React, {useState,Fragment, useEffect} from "react";
import UseForm from '../NewsLetter/UseForm';

import dataServices from "../../common/dataServices";
import "./ModalContactUs.css";

const ModalContactUs =  (props) => {
  const errorStyle = {
    color: 'red'
    ,fontSize: '14px'
  ,fontFamily:'Roboto'      
  ,margin:'0px'
  };
    const [showModal,setShowModal]=useState(false);
    const [isSucc,setIsSucc] = useState(null);
    const constNewsLetterObj={ Fields:{
        Title: {value: 'popup contact us form' ,error:''}
         ,MashanContent: { value: '',error:'' }
        ,MashanPhoneNumber: { value: '',error:'' }
         ,MashanContactUsChoice: { value: '', error:''}
        ,MashanFirstName: { value: '', error:''}
         ,MashanLastName: { value: '', error:''}
        ,MashanEmail: { value: '', error:''}
        
    },
    MailTo:'',
    //the key in webconfig
    type: 1
    , webUrl: props.mainURL
    };
    let validationStateSchema = {
        Title: { },
        MashanContactUsChoice:{},
        MashanContent:{},
        MashanFirstName: {
           required: true,
          validator: {
            regEx:/^[a-zA-Z\u0590-\u05ff]+?[a-zA-Z\u0590-\u05ff_ ]+$/,
            error: 'Invalid first name format.',
          },
        },
        MashanLastName: {
            // required: true,
            // validator: {
            //   regEx:/^[a-zA-Z\u0590-\u05ff]+?[a-zA-Z\u0590-\u05ff_ ]+$/,
            //   error: 'Invalid last name format.',
            // },
          },
          MashanPhoneNumber: {
          required: true,
           validator: {
            // regEx:/^[0-9]+? $/,
            //regEx:/^[0-9]*$/,
            //regEx:/^\d+$/,
            //regEx:/^-?\d*\.?\d*$/,
            regEx:/^[\d ]*$/,
             error: 'Only numbers allowed',
          }
         },
        MashanEmail: {    
          required: true,
            validator: {
              regEx:  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
              error: 'Invalid mail format.',
            },
          },
    
      };
      useEffect(()=>{
      
      },[]);
     
      const CloseModal=()=>{
        props.CloseModal();
      };
    const onSubmitForm  =(state) =>{
            dataServices.setItems(state).then(response=>{
                setIsSucc(true);
              })
              .catch((error)=>
              {
                 setIsSucc(false);
              });
    };
    const { state, handleOnChange, handleOnSubmit, disable } = UseForm(constNewsLetterObj,validationStateSchema,onSubmitForm  );
    return(<div>
               {/* { props.showModal 
                &&  */}
                <div>
    
        <div className=" show"  role="dialog" aria-hidden="true" id="modmodal" aria-modal="true">
          {/* <div role="document" className="modal-dialog modal-dialog-centered"> */}
          <div role="document" className="contactusmodal-dialog contactusmodal-dialog-centered">
          <fieldset legend='contact us form' role="contact us group" >
          <form  onSubmit={handleOnSubmit}  role="form" >
                <div  className="modal-content mashan-contact-modal">
                <div className="close-btn" onClick={CloseModal}>x</div>
                <div  className="mashan-contact-modal-title">CONTACT ME FORM</div>
                <div  className="mashan-contact-modal-sub-title">Leave your details and we will contact you</div>
                    <div className="modal-body  col-12 ">
                  
                          <div className={'col-12 col-md-12'}>
                                    <div className="contactusmodal-input-warpper col-12 col-md-12">
                                        <div className="contactusmodal-form-field contactusmodal-field-title col-12 col-md-12">
                                                  <label className="col-12 col-md-12" htmlFor={'first-name-news-letter'}>NAME</label>
                                                  <input
                                                  type='text'
                                                  onChange={handleOnChange} 
                                                  value={state.Fields["MashanFirstName"].value}
                                                  name='MashanFirstName'
                                                  className={"col-12 col-md-12 "  && state.Fields["MashanFirstName"].error && 'error-border'}
                                                    id={'MashanFirstName'}  placeholder="Required Field"
                                                    aria-invalid={state.Fields["MashanFirstName"].error  ? 'true':'false'}
                                                    required
                                              aria-required={true}
                                              aria-describedby={"error_contactusmodal_mashanfirstname"}
                                                    />
                                                  {state.Fields["MashanFirstName"].error && <p id='error_contactusmodal_mashanfirstname' style={errorStyle} className="error-message">{state.Fields["MashanFirstName"].error}</p>}
                                        </div>
                                        <div className="contactusmodal-form-field contactusmodal-field-title col-12 col-md-12">
                                                    <label className="col-12 col-md-12" htmlFor={'phone-news-letter'}>PHONE NUMBER</label>
                                                    <input 
                                                    className={"col-12 col-md-12 " && state.Fields["MashanPhoneNumber"].error && 'error-border'}
                                                      type='text'  id={'phone-news-letter'}  placeholder="Required Field"
                                                    onChange={handleOnChange}  name='MashanPhoneNumber'
                                                    value={state.Fields["MashanPhoneNumber"].value}
                                                    aria-invalid={state.Fields["MashanPhoneNumber"].error  ? 'true':'false'}
                                                    required
                                              aria-required={true}
                                              aria-describedby={"error_contactusmodal_mashanphone"}
                                                    />
                                                    {state.Fields["MashanPhoneNumber"].error && <p id={'error_contactusmodal_mashanphone'} style={errorStyle} className="error-message">{state.Fields["MashanPhoneNumber"].error}</p>}
                                          </div>
                                        <div className="contactusmodal-form-field contactusmodal-field-title col-12 col-md-12">                           
                                                    <label className="col-12 col-md-12" htmlFor={'mail-news-letter'}>MAIL</label>
                                                    <input 
                                                      className={"col-12 col-md-12 " && state.Fields["MashanEmail"].error && 'error-border'}  type='text' 
                                                       id={'mail-news-letter'} placeholder="Required Field"
                                                    onChange={handleOnChange}  name='MashanEmail'
                                                    value={state.Fields["MashanEmail"].value}
                                                    aria-invalid={state.Fields["MashanEmail"].error  ? 'true':'false'}
                                                    required
                                              aria-required={true}
                                              aria-describedby={"error_contactusmodal_mashanemail"}
                                                    />
                                                    {state.Fields["MashanEmail"].error && <p id="error_contactusmodal_mashanemail"
                                                     style={errorStyle} className="error-message">{state.Fields["MashanEmail"].error}</p>}           
                                         </div>
                                         
                                    </div>  
                                <button className='btn btn-primary col-12' type="submit" name="submit">SEND</button>
                                {isSucc ===  true ? 
                                     <div className="server-msg">Your request was sent.</div>                                    
                             : isSucc===false? <div className="server-msg">Error occurred, Please try later;</div> :''
                }
                            </div>
                          
                </div>        
            </div> 
            </form>       
            </fieldset>
        </div>
            <div className="modal fade show" aria-hidden="true" aria-modal="true"></div>
        </div>
       
        </div>
        
     
       </div>
       )
};

export default ModalContactUs;
